import { getValidIdToken } from './authService'

const BASE_URL = 'https://gdujko8z9g.execute-api.us-east-1.amazonaws.com';

export const LAMBDA = {
    READDASHBOARD: `${BASE_URL}/cast-n-track-lambda-readDashboard`,
    READ: `${BASE_URL}/cast-n-track-lambda-read`,
    CREATE: `${BASE_URL}/cast-n-track-lambda-create`,
    UPDATE: `${BASE_URL}/cast-n-track-lambda-update`,
    DELETE: `${BASE_URL}/cast-n-track-lambda-delete`,
    PRESIGNER: `${BASE_URL}/cast-n-track-lambda-preSigner`,
    DELETES3FILE: `${BASE_URL}/cast-n-track-lambda-deleteS3File`
}

export async function runLambda( lambdaFunction, bodyString ) {

    console.log("runLambda(",lambdaFunction, ") called with:", bodyString )

    const token = await getValidIdToken();
    return await fetch(lambdaFunction, { method: 'POST',
        headers: { 'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` },
            body: bodyString } ) ;
}
